import { sendPostMessage, getParentWindow } from "../../utils/browserUtils";
import postMessageTypes from "../../constants/messageTypes";
// FIXME: REMOVE Once changes are made from kite
const KITE_ORIGIN = "https://kite.zerodha.com";

export const POPUP_CLOSE_GRACE_MS = 500;

const POSTMESSAGE_ACK = "POSTMESSAGE_ACK";
const POPUP_SELF_CLOSING = "POPUP_SELF_CLOSING";

/**
 * @param {{primaryWindow: PrimaryNewTab, delayMs: number}} param0
 * @returns {{promise: Promise<boolean>, cancel: () => void, intervalID: number}}
 */
function onWindowClosePromise({ primaryWindow, delayMs = 500 }) {
  const returnObj = {
    promise: undefined,
    cancel: undefined,
    intervalID: undefined,
    graceTimeoutID: undefined,
  };

  returnObj.promise = new Promise((resolve) => {
    returnObj.intervalID = setInterval(() => {
      const { windowInstance } = primaryWindow;
      if (windowInstance === undefined || !windowInstance.closed) return;

      clearInterval(returnObj.intervalID);

      const isSelfClosed = primaryWindow.expectedSelfClose;
      if (isSelfClosed) {
        resolve(isSelfClosed);
        return;
      }

      // A result announcing self-close can still arrive after the popup is gone,
      // so re-read the marker once the grace window expires.
      returnObj.graceTimeoutID = setTimeout(
        () => resolve(primaryWindow.expectedSelfClose),
        POPUP_CLOSE_GRACE_MS,
      );
    }, delayMs);
  });

  returnObj.cancel = () => {
    clearInterval(returnObj.intervalID);
    clearTimeout(returnObj.graceTimeoutID);
  };

  return returnObj;
}

/**
 * @param {{primaryWindow: PrimaryNewTab, delayMs: number}} param0
 * @returns {{promise: Promise<void>, cancel: () => void, intervalID: number}}
 */
function onWindowCloseSendMessagePromise({ primaryWindow, delayMs = 500 }) {
  const promiseObj = onWindowClosePromise({
    primaryWindow,
    delayMs,
  });

  promiseObj.promise = promiseObj.promise.then((isSelfClosed) => {
    // send message only if window was not self closed
    if (!isSelfClosed) {
      sendPostMessage({
        messageType: postMessageTypes.CLOSED_WINDOW,
        messageParams: {
          windowType: "newtab",
        },
      });
    }
  });

  return promiseObj;
}

function setupMessageForwarding(WindowManager) {
  function forwardOnMessage(ev) {
    if (ev.data.type !== undefined && ev.source !== getParentWindow()) {
      if (ev.data.type === POSTMESSAGE_ACK) return;

      // The popup announces this the moment it decides to close itself, so it
      // is never forwarded and there is nobody left to acknowledge.
      if (ev.data.type === POPUP_SELF_CLOSING) {
        const primary = WindowManager._instance &&
          WindowManager._instance._window.primary;
        if (primary && primary.windowType === "newtab" &&
          ev.source === primary.windowInstance) {
          primary.expectedSelfClose = true;
        }
        return;
      }

      const meta = ev.data.meta;

      if (ev.source) {
        try {
          const ack = { type: POSTMESSAGE_ACK };
          if (meta && typeof meta === "object") ack.meta = meta;
          ev.source.postMessage(ack, ev.origin);
        } catch (error) {
          // a failed ACK must not discard the business result
        }
      }

      // if event has type and have not originated from parent (allow only from its own children),
      // then forward it to parent
      if (ev.data.type === "GATEWAY_LOGIN") {
        // also save the source of the event, given we have to return the message to source
        window._sourceWindow = ev.source;
      }
      sendPostMessage({
        messageType: ev.data.type,
        messageParams: {
          ...ev.data,
        },
      });
    }
  }

  window.addEventListener("message", forwardOnMessage);

  return {
    cancel: () => window.removeEventListener("message", forwardOnMessage),
  };
}

// FIXME: Remove this method when changes from kite are done
function setupKiteHoldingAuthorizationForwarding(iframeWindow) {
  function forwardOnMessage(ev) {
    if (ev.origin === KITE_ORIGIN) {
      iframeWindow.postMessage(ev.data, "*");
    }
  }
  window.addEventListener("message", forwardOnMessage);
}

export {
  onWindowCloseSendMessagePromise,
  setupMessageForwarding,
  setupKiteHoldingAuthorizationForwarding,
};



// WEBPACK FOOTER //
// ./logic/WindowManager/windowListeners.js